/* globals sift */
angular.module('zc.zenclerkS')

  .component('zcsCampaignsList', {
    templateUrl: '/templates/zenclerk_s/sites/campaigns/list/campaigns_list.html',
    bindings: {
      project: '<',
      filters: '<',
      titles: '<'
    },
    controller: zcsCampaignsListController
  });

zcsCampaignsListController.$inject = ['$filter', '$q', '$scope', '$state', 'Project', 'Campaign', 'CampaignStats', 'ReportCampaignStats', 'ReportRange'];
function zcsCampaignsListController($filter, $q, $scope, $state, Project, Campaign, CampaignStats, ReportCampaignStats, ReportRange) {
  const vm = this;

  vm.$onInit = () => {
    vm.pagination = {
      itemsPerPage: 25,
      currentPage: 1
    };
    vm.Project = Project;

    vm.showStats = true;
    vm.campaigns = [];

    vm.pageChanged = pageChanged;
    vm.removeCampaign = removeCampaign;

    Campaign.all({ projectId: vm.project.id })
      .then(function(res) {
        vm.campaigns = sift(vm.filters, res);
        vm.campaigns = _.chain(vm.campaigns)
          .sortBy(d => -new Date(d.start_at))
          .value();
        pageChanged();
      });
  };

  function pageChanged() {
    vm.pagedCampaigns = _.chain(vm.campaigns)
      //.filter((d) ->
      //  d.start_at > moment().subtract(2, 'months').toDate()
      //)
      //.sortBy((d) -> -d.start_at.valueOf())
      .value();
    //begin = scope.pagination.itemsPerPage * (scope.pagination.currentPage-1)
    //end = begin + scope.pagination.itemsPerPage
    //scope.pagedCampaigns = scope.pagedCampaigns.slice begin, end
  }

  function removeCampaign(campaign) {
    const index = _.findIndex(vm.campaigns, campaign);
    vm.campaigns.splice(index, 1);
  }

  $scope.$watch('$ctrl.filters', function(newValue) {
    if(!newValue) { return }
    vm.filters = newValue;
    vm.pageChanged();
  }, true);
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/list/campaigns_list.directive.js